import type { MerchantValues, Validators } from './types'
import { websiteMask } from 'utils/masks'

const name = (values: MerchantValues) => {
  return !values.name?.trim() ? 'error.fieldRequired' : null
}

const website = (values: MerchantValues) => {
  if (!values.website) return 'error.fieldRequired'
  if (!websiteMask.test(values.website)) return 'error.websiteExample'
  return null
}

const country = (values: MerchantValues) => {
  return !values.country?.id ? 'error.fieldRequired' : null
}

const canonicalLocaleId = (values: MerchantValues) => {
  return !values.canonicalLocaleId ? 'error.fieldRequired' : null
}

const validators: Validators = {
  status: () => null,
  name,
  website,
  country,
  canonicalLocaleId,
}

export default validators
